import { render, staticRenderFns } from "./MandellsStepper.vue?vue&type=template&id=248e758b&scoped=true"
import script from "./MandellsStepper.vue?vue&type=script&lang=js"
export * from "./MandellsStepper.vue?vue&type=script&lang=js"
import style0 from "./MandellsStepper.vue?vue&type=style&index=0&id=248e758b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e758b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperHeader})
